import type { MetaFunction } from 'react-router'
import ContactPage from '~/pages/ContactPage.jsx'

export const meta: MetaFunction = () => [
  { title: 'Contact Us | S.J.S. Technology' },
  {
    name: 'description',
    content:
      'Contact S.J.S. Technology, Bengaluru — #17 G.B. Lane, Cottonpete. Call +91 88849 90111 for VICTORY machine demos, pricing, and service support.',
  },
  { property: 'og:title', content: 'Contact Us | S.J.S. Technology' },
  { property: 'og:url', content: 'https://sjstechnology.in/contact' },
]

export default function Contact() {
  return <ContactPage />
}
